<!--Copy right - © 2024 tecera gmbh-->
<script>
    import {
        is_authenticated,
        check_if_authenticated,
        user_permissions,
        user_role,
        rerout_user,
    } from "../scripts/auth.js";
    import NavBar from "../components/NavBar.svelte";
    import Footer from "../components/Footer.svelte";
    import { onDestroy, onMount } from "svelte";
    import {
        selected_device,
        current_device_data,
        all_devices,
    } from "../stores.js";
    import { BASE_API_URL } from "../config.js";
    import DataTabelle from "../components/DataTabelle.svelte";
    import DeviceSearchField from "../components/DeviceSearchField.svelte";
    import DeviceButtonSimple from "../components/buttons/DeviceButtonSimple.svelte";

    let loading;
    let is_mounted = false;
    onMount(async () => {
        $current_device_data = null;
        $selected_device = null;
        await check_if_authenticated();
        if (!$user_role["view_assembly"] || $user_role["view_assembly"] != 1) {
            rerout_user();
            return;
        }
        loading = get_devices();
        is_mounted = true;
    });
    
    async function get_devices() {
        let url_extension = `/devices/`;
        let request_url = BASE_API_URL + url_extension;
        try {
            const response = await fetch(request_url, {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            $all_devices = data;
            $selected_device = data[0];
            return true;
        } catch (error) {
            return false;
        }
    }

    async function get_devices2(id) {
                if ($selected_device.channels.length == 0){
            return;
        }
        let url_extension = `/device_data/${id}/`;
        let request_url = BASE_API_URL + url_extension;
        try {
            const response = await fetch(request_url, {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(
                    `with statuscode: ${response.status}\n${data.error}`,
                );
            }
            $current_device_data = data.data;
            return true;
        } catch (error) {
            return false;
        }
    }

    onDestroy(() => {
        $selected_device = null;
        $all_devices = [];
        $current_device_data = [];
    });

    let device_search_input = "";

    // reactive centering of the map on the selected device
    $: {
        if (
            $selected_device &&
            $all_devices.some((device) => device === $selected_device)
        ) {
            // added .some check so wrong device type can't be selected
            get_devices2($selected_device.id);
        }
    }
</script>

<svelte:head>
    <title>Mapview - Montage</title>
</svelte:head>

{#if $is_authenticated && $user_role && $user_role["view_assembly"] == 1}
    <div class="container-fluid">
        <div class="row">
            <!-- Main Content -->
            <main class="col-12 ml-sm-auto px-md-4">
                <NavBar headline="Montage-Übersicht" />

                <div class="row">
                    <!-- Linke Seite -->
                    <div class="col-12 col-lg-8 col-xl-9 content_main" style="display:flex;flex-direction:column;justify-content:flex-start;">
                            <p class="p-kachel mt-3" style="flex: 0 0 4%; white-space:wrap;align-self:flex-start;">
                                   Aktuelle Auswahl:&nbsp;&nbsp;&nbsp;&nbsp; {$selected_device
                                    ? $selected_device.dev_eui
                                    : ""}
                            </p>
                        <!-- Tabelle -->
                        <div class="row" style="flex: 1 1 40%;overflow:hidden;">
                            <DataTabelle {is_mounted} />
                        </div>
                    </div>

                    <!-- Rechte Seite -->
                    <!-- Rechte Seite für Sensorübersicht -->

                    <div
                        class="col-12 col-lg-4 col-xl-3 content_main content_main_side"
                    >
                        <!-- HyMo Menü -->
                        <div class="row pt-4 full">
                            <div class="col-12 full">
                                <div class="display_box side-menu">
                                    <p class="p-kachel">Geräte</p>

                                    <!-- Suchfeld -->
                                    <DeviceSearchField
                                        bind:device_search_input
                                    />

                                    <div
                                        id="device_menu"
                                        class="scroll_window_admin mt-4"
                                    >
                                        <!-- Darstellungsraum der Devices -->
                                        {#await loading}
                                            <div
                                                id="loader_devices"
                                                class="loader"
                                            />
                                        {:then}
                                            {#each $all_devices as device (device.id)}
                                                {#if !device.dev_eui || device.dev_eui
                                                        .toLowerCase()
                                                        .includes(device_search_input.toLowerCase())}
                                                    <DeviceButtonSimple
                                                        {device}
                                                    />
                                                {/if}
                                            {/each}
                                        {/await}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>

    <!-- Sensor Entfernen Sicherheitsabfrage -->

    <div
        class="modal fade"
        id="realy_delete"
        tabindex="-1"
        role="dialog"
        aria-labelledby="realy_delete"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <!-- Header für aktive Nutzerliste -->
                    <h5 class="modal-title" id="deleteTitleSensor">
                        Kundenzuordnung aufheben?
                    </h5>
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- Modal Body -->
                <div class="modal-body">
                    <p id="delete_message"></p>
                </div>

                <!-- Modal Footer -->
                <div class="modal-footer">
                    <!-- Footer für aktive Nutzerliste -->
                    <button
                        type="button"
                        class="btn btn-primary"
                        id="realy_delete_btn"
                        value=""
                        data-dismiss="modal">Zuordnung aufheben</button
                    >
                    <!-- Abbrechen Button, falls es nicht gelöscht werden soll -->
                    <button
                        type="button"
                        class="btn btn-primary"
                        data-dismiss="modal">Abbrechen</button
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Quit Sicherheitsabfrage -->

    <div
        class="modal fade"
        id="realy_quit"
        tabindex="-1"
        role="dialog"
        aria-labelledby="realy_quit"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <!-- Header für aktive Nutzerliste -->
                    <h5 class="modal-title" id="deleteTilteMeldungen">
                        Meldung quittieren?
                    </h5>
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- Modal Body -->
                <div class="modal-body">
                    <p id="quit_message"></p>
                </div>

                <!-- Modal Footer -->
                <div class="modal-footer">
                    <!-- Footer für aktive Nutzerliste -->
                    <button
                        type="button"
                        class="btn btn-primary"
                        id="realy_quit_btn"
                        value=""
                        data-dismiss="modal">Quittieren</button
                    >
                    <!-- Abbrechen Button, falls es nicht quittiert werden sollte -->
                    <button
                        type="button"
                        class="btn btn-primary"
                        data-dismiss="modal">Abbrechen</button
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <Footer />
{/if}
